import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    fetched: false,
    isFetchedTree: false,
    savingInProgress: false,
    repairtimes: [],
    currentRepairTimeType: { price: 0 },
    repairtimetypes: [],
    isFullTree: null //'full' Or null - полное дерево или без скрытых узлов
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    updateRepairtimesTreeChildren(state, payload) {
      let data = JSON.parse(JSON.stringify(state.repairtimes));
      this._vm.$set(
        state,
        "repairtimes",
        recursiveTreeUpdate(data, payload.id, payload.value, payload.type)
      );
    },
  },
  actions: {
    async repairtimeCustomDelete({ commit, state, dispatch }, payload) {
      this._vm.$confirm( {
        title : this._vm.i18n.t('common.confirm'),
        text : this._vm.i18n.t('common.confirm_remove'),
        cancelText : this._vm.i18n.t('common.no'),
        acceptText : this._vm.i18n.t('common.yes')
      } ).then( async y  => {
        updateField(state, { path: "savingInProgress", value: true });
        return await axios
            .delete(
                this._vm.$apiURL + `/repairtimes-custom/${payload.id}`
            )
            .then((response) => {
              dispatch("get", {'type':'full'});
              return true;
            })
            .catch((error) => {
              dispatch("common/showError", { error: error }, { root: true });
            })
            .finally(() => {
              updateField(state, { path: "savingInProgress", value: false });
            });
      }).catch( n => {} );

    },
    async repairtimeCustomUpdate({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
          .put(
              this._vm.$apiURL + `/repairtimes-custom/${payload.id}`,
              payload
          )
          .then((response) => {
            dispatch("get", {'type':'full'});
            return true;
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(() => {
            updateField(state, { path: "savingInProgress", value: false });
          });
    },
    async repairtimeCustomStore({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
          .post(
              this._vm.$apiURL + "/repairtimes-custom",
              payload
          )
          .then((response) => {
            dispatch("get", {'type':'full'});
            return true;
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(() => {
            updateField(state, { path: "savingInProgress", value: false });
          });
    },
    /**
     * Toggle Repairtime hidden для данного Shop
     * @param commit
     * @param state
     * @param dispatch
     * @param payload
     * @returns {Promise<void>}
     */
    async repairtimeHiddenStore({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
          .post(
              this._vm.$apiURL + "/repairtimes-hidden-toggle",
              payload
          )
          .then((response) => {
            dispatch("get", {'type':'full'});
            return true;
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(() => {
            updateField(state, { path: "savingInProgress", value: false });
          });
    },
    async get({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isFetchedTree", value: false });
      await axios
        .get(this._vm.$apiURL + "/repairtimes", { params: payload })
        .then((response) => {
          updateField(state, {
            path: "isFullTree",
            value: payload && payload.type==='full',
          });
          updateField(state, { path: "isFetchedTree", value: true });
          return updateField(state, {
            path: "repairtimes",
            value: response.data,
          });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async overrideRepairtime({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .put(
          this._vm.$apiURL + "/repairtimes/" + payload.id + "/override",
          payload
        )
        .then((response) => {
          commit("updateRepairtimesTreeChildren", {
            id: payload.id,
            value: response.data.updated,
            type:  response.data.type
          });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async typesGet({ commit, state, dispatch }) {
      updateField(state, { path: "fetched", value: true });
      await axios
        .get(this._vm.$apiURL + "/repairtimetypes")
        .then((response) => {
          if (response.data[0])
            updateField(state, {
              path: "currentRepairTimeType",
              value: response.data[0],
            });
          return updateField(state, {
            path: "repairtimetypes",
            value: response.data,
          });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async updateRepairTimeType({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .put(this._vm.$apiURL + "/repairtimetypes/" + payload.id, payload)
        .then((response) => {
          return response.data.id;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    clear({ commit, state, dispatch }) {
      updateField(state, {
        path: "payment",
        value: {
          type: null,
          value: null,
          customer_id: null,
        },
      });
    },
  },
};

function recursiveTreeUpdate(array, index, newData, type) {
  if (Array.isArray(array)) {
    for (let i in array) {
      array[i] = recursiveTreeUpdate(array[i], index, newData, type);
    }
  } else {

    if (array["id"] === index && array["type"]===type) {
      let tmpChildren = array["children"];
      array = newData;
      array["children"] = tmpChildren;
    } else {
      if (array["children"]) {
        array["children"] = recursiveTreeUpdate(
          array["children"],
          index,
          newData,
          type
        );
      }
    }
  }
  return array;
}

function recursiveTreePush(index, data) {}
